module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_Wood_MockedUp.0d055cf0.jpg";